//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "FontSizeChoice",

  props: {
    size: {
      type: Number,
      default: 14
    },
    iconTooltip: {
      type: String,
      default: 'Размер шрифта'
    },
    options: {
      type: Array,
      default: () => []
    },
  },
}
